import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import D3ChartComponent from './D3ChartComponent';

export const D3Chart = Node.create({
  name: 'd3Chart',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      chartType: {
        default: 'bar',
      },
      chartData: {
        default: [],
      },
      chartOptions: {
        default: {
          width: '100%',
          height: 400,
          title: '',
          xLabel: '',
          yLabel: '',
          colors: ['#3b82f6', '#ef4444', '#10b981', '#f59e0b', '#8b5cf6'],
          showLegend: true,
          showTooltip: true,
          innerRadius: 0, // For donut charts
          padding: 0.1, // For bar charts
        },
      },
      chartId: {
        default: () => `chart-${Math.random().toString(36).substr(2, 9)}`,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="d3-chart"]',
        getAttrs: (element) => {
          const chartData = element.getAttribute('data-chart-data');
          const chartOptions = element.getAttribute('data-chart-options');
          const chartType = element.getAttribute('data-chart-type');

          return {
            chartType: chartType || 'bar',
            chartData: chartData ? JSON.parse(chartData) : [],
            chartOptions: chartOptions ? JSON.parse(chartOptions) : {},
          };
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      {
        ...HTMLAttributes,
        'data-type': 'd3-chart',
        'data-chart-type': HTMLAttributes.chartType,
        'data-chart-data': JSON.stringify(HTMLAttributes.chartData),
        'data-chart-options': JSON.stringify(HTMLAttributes.chartOptions),
        style: 'width: 100%; margin: 20px 0;',
      },
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(D3ChartComponent);
  },

  addCommands() {
    return {
      insertChart: (attributes) => ({ commands }) => {
        return commands.insertContent({
          type: this.name,
          attrs: attributes,
        });
      },
    };
  },
});

export default D3Chart;